'use strict'

import Vue from 'vue'
import ServiceHolder from '@/app/plugins/service/service-holder'
import VueBackClient from '@/app/plugins/transport/vue-back-client'
import PageManager from '@/app/stage/page-manager'
import router from '@/router/router'
import store from '@/store/store'
import commonConfig from '@/app/config/common-config'

class VuePluginInitializer {
  static init() {
    return new Promise((resolve) => {
      Vue.use(PageManager, store, router)

      const HTTP_ADDRESS = `${commonConfig.getUrlApi()}`
      Vue.use(VueBackClient, HTTP_ADDRESS, store, router)

      Vue.use(ServiceHolder, {
        http: Vue.prototype.$http,
        store,
        pageManager: Vue.prototype.$pageManager
      })
      resolve()
    })
  }
}

export default VuePluginInitializer
